/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

/**
 * The theme types.
 */
export enum ThemeType {
    /**
     * The dark theme identifier.
     */
    Dark = "dark",

    /**
     * The high contrast theme identifier.
     */
    HighContrast = "highContrast",

    /**
     * The light theme identifier.
     */
    Light = "light"
}
